import React from 'react';
import { 
  Target, BarChart3, Globe, Video, ShoppingCart, 
  Rocket, Share2, FileText, ArrowRight 
} from 'lucide-react';
import { Link } from 'react-router-dom';
import { servicesDetailed } from '../data/mockData';

export const Services = () => {
  const icons = {
    Target,
    BarChart3,
    Globe,
    Video,
    ShoppingCart,
    Rocket,
    Share2,
    FileText
  };

  return (
    <div className="bg-[rgb(17,17,19)] min-h-screen">
      {/* Hero Section */}
      <section className="pt-32 pb-20 relative overflow-hidden">
        <div className="absolute inset-0 opacity-5">
          <div
            className="absolute inset-0"
            style={{
              backgroundImage:
                'radial-gradient(circle, rgb(0,250,99) 1px, transparent 1px)',
              backgroundSize: '50px 50px'
            }}
          />
        </div>

        <div className="container mx-auto px-6 relative z-10">
          <div className="max-w-4xl mx-auto text-center">
            <div className="inline-block px-6 py-2 bg-[rgba(0,250,99,0.1)] border border-[rgba(0,250,99,0.3)] rounded-full mb-6">
              <span className="text-[rgb(0,250,99)] text-sm font-medium">
                Our Services
              </span>
            </div>
            <h1 className="text-5xl md:text-6xl font-bold text-white mb-6">
              Comprehensive Solutions for Healthcare Brands
            </h1>
            <p className="text-xl text-[rgb(218,218,218)]">
              From strategy to execution, we provide end-to-end marketing services designed specifically for the healthcare and wellness industry
            </p>
          </div>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16 pb-24">
        <div className="container mx-auto px-6">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 max-w-7xl mx-auto">
            {servicesDetailed.map((service) => {
              const Icon = icons[service.icon];
              return (
                <div
                  key={service.id}
                  id={service.slug}
                  className="group bg-[rgb(26,28,30)] border border-[rgba(255,255,255,0.1)] rounded-2xl p-8 hover:-translate-y-2 transition-all duration-300 hover:border-[rgb(0,250,99)] relative overflow-hidden"
                >
                  {/* Top Accent */}
                  <div className="absolute top-0 left-0 right-0 h-0.5 bg-[rgb(0,250,99)] opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

                  {/* Icon */}
                  <div className="w-14 h-14 rounded-xl bg-[rgba(0,250,99,0.1)] flex items-center justify-center mb-6 group-hover:bg-[rgb(0,250,99)] transition-colors duration-300">
                    <Icon
                      size={28}
                      className="text-[rgb(0,250,99)] group-hover:text-[rgb(17,17,19)] transition-colors duration-300"
                    />
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-semibold text-white mb-4 group-hover:text-[rgb(0,250,99)] transition-colors">
                    {service.title}
                  </h3>
                  <p className="text-[rgb(161,161,170)] leading-relaxed mb-6">
                    {service.description}
                  </p>

                  {/* Learn More Link */}
                  <div className="inline-flex items-center space-x-2 text-[rgb(0,250,99)] font-medium group/link cursor-pointer">
                    <span>Get Started</span>
                    <ArrowRight
                      size={18}
                      className="group-hover/link:translate-x-1 transition-transform"
                    />
                  </div>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-24 bg-[rgb(26,28,30)]">
        <div className="container mx-auto px-6">
          <div className="max-w-4xl mx-auto text-center">
            <h2 className="text-4xl md:text-5xl font-bold text-white mb-6">
              Ready to Transform Your Healthcare Brand?
            </h2>
            <p className="text-xl text-[rgb(218,218,218)] mb-8">
              Let's discuss how our services can help you achieve your marketing goals
            </p>
            <Link
              to="/contact"
              className="inline-flex items-center space-x-2 px-8 py-4 bg-[rgb(0,250,99)] text-[rgb(17,17,19)] rounded-xl font-semibold text-lg hover:bg-[rgb(0,220,87)] transition-all duration-200 hover:-translate-y-1 hover:shadow-[0_8px_25px_rgba(0,250,99,0.3)]"
            >
              <span>Schedule a Consultation</span>
              <ArrowRight size={20} />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};
